import * as React from 'react';
import { Language } from '../interfaces/interfaces';
import { Link } from 'react-router-dom';
import * as i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import { flags } from '../../constants/flags';
import { useLanguages, useLanguagesMatch } from '../../hooks/useLanguages';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

interface IProps {
    uniqueSiteId: number;
}

function AdminSiteCharacteristics({ uniqueSiteId }: IProps) {
    const { data: languageCodes } = useLanguages();
    const languagesMatch = useLanguagesMatch();

    React.useEffect(() => {
        if (languageCodes && languageCodes.length > 0 && !languagesMatch) {
            throw new Error('Language mismatch between client and server!');
        }
    }, [languageCodes, languagesMatch]);

    function renderLanguage(lang: Language) {
        return (
            <Box key={lang.cultureCode} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                <span
                    title={i18next.t(lang.languageTag)}
                    className={lang.flag + 'loginFlags'}
                    style={{ width: 30, height: 25, cursor: 'default', display: 'inline-block', flexShrink: 0 }}
                />
                <Typography
                    component={Link}
                    to={'/administrationsitedetail/' + uniqueSiteId + '/' + lang.cultureCode}
                    sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                >
                    {i18next.t(lang.languageTag)}
                </Typography>
            </Box>
        );
    }

    return (
        <Box>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                {i18next.t('adminsites.language')}
            </Typography>
            <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 1.5 }}>
                {flags.map(lang => renderLanguage(lang))}
            </Paper>
        </Box>
    );
}

export default withTranslation('translations')(AdminSiteCharacteristics);
